import { IPIconButton, IPLink, IPTooltipHost } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import DialogYesNo from 'components/Dialogs/DialogYesNo';
import {
  deleteIcon,
  globalStackTokensGapSmall,
} from 'globalStyles';
import ResourceLink from 'models/resourceLink';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IPinnedLinkLinkProps {
  link: ResourceLink;
  readonly: boolean;
  onClick: (item: ResourceLink) => void;
  onDelete: (item: ResourceLink) => void;
}

const PinnedLinkLink = (props: IPinnedLinkLinkProps) => {
  const { t } = useTranslation(['translation', 'library']);
  const [deleteLink, setDeleteLink] = useState<ResourceLink | undefined>(undefined);

  //
  // Main render
  //
  return (
    <IPStack horizontal tokens={globalStackTokensGapSmall} verticalAlign="center">
      <IPStack.Item grow>
        <IPStack horizontal verticalAlign="center">
          <IPStack.Item grow>
            <IPLink onClick={() =>props.onClick(props.link)}>{props.link.linkName}</IPLink>
          </IPStack.Item>
          <IPStack.Item>
            {!props.readonly && (
              <IPTooltipHost content={t('translation:General.Button.Remove')}>
                <IPIconButton
                  iconProps={deleteIcon}
                  onClick={() => {
                    setDeleteLink(props.link);
                  }}
                />
              </IPTooltipHost>
            )}
          </IPStack.Item>
        </IPStack>
      </IPStack.Item>
      <DialogYesNo
        hidden={deleteLink === undefined}
        title={t('library:LinkComponents.RemoveTitle')}
        subText={t('library:LinkComponents.RemoveSubText')}
        onYes={() => {
          if (deleteLink && props.onDelete) props.onDelete(deleteLink);
          setDeleteLink(undefined);
        }}
        onNo={() => {
          setDeleteLink(undefined);
        }}
      />
    </IPStack>
  );
};

export default PinnedLinkLink;
